module.exports = __webpack_public_path__ + "img/sc.e6288046.svg";